import { useEffect, useRef } from "react";
import Typed from "typed.js";

export default function TypedTitle() {
  // Create reference to store the DOM element containing the animation
  const el = useRef(null);

  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: ["Front-End Developer", "&amp; ReactJS Developer"],
      typeSpeed: 70,
      loop: true,
    });

    return () => {
      // Destroy Typed instance during cleanup to stop animation
      typed.destroy();
    };
  }, []);

  return <span ref={el} />;
}
